module.exports = __webpack_public_path__ + "img/FLO.e67b4a81.svg";